import { NavigateOptions, useNavigate } from 'react-router-dom'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { Routes } from 'common/constants'
import { TTagType } from 'common/types/ServiceCommon.types'
import { getTagColor, getTagtext } from 'common/services'

import { TServiceButton } from '../types/ServiceButton.types'

export const useServiceButton = ({
  title,
  details,
  icon,
  route,
  status,
  info = {
    openingDate: '',
    protocol: '',
    hasUpdate: false,
    areaResponse: '',
  },
}: TServiceButton) => {
  const navigate = useNavigate()

  const { privacyCenterContent, userSelectedEntity } = useAppContext()

  const content = privacyCenterContent?.components?.supportData

  if (!content) return null

  const { filterDictionary } = content

  const theme: TTagType = getTagColor(status)

  const tagStatus = getTagtext(filterDictionary, status)

  const navigateParams: NavigateOptions = {
    state: { ...info, status, subject: title, details },
  }

  const navigateTo = async () => {
    try {
      await sendSelectContent({
        flow: 'my_services',
        step: 'my_service_requests',
        screen_name: Routes.MY_SERVICE_REQUESTS,
        element_name: 'goToRequestDetails',
        element_type: 'button',
        parent_name: 'MyServices',
        scenario: JSON.stringify({
          screen: Routes.MY_SERVICE_REQUESTS,
          product: userSelectedEntity,
          title,
          details,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send service button tic', error)
    }

    navigate(route, navigateParams)
  }

  return {
    content: {
      title,
      icon,
      theme,
      tagStatus,
      hasUpdate: info.hasUpdate,
      navigateTo,
    },
  }
}
